// src/area/ConfigCategoryArea/ConfigCategoryArea.jsx
import React, { useState, useEffect } from "react";
import CardConfigCategoryGeneral2 from "../../components/Cards/CardConfiguration/CardConfigCategoryGeneral/CardConfigCategoryGeneral2";

import CardConfigCategoryDetalles from "../../components/Cards/CardConfiguration/CardConfigCategoryDetalles/CardConfigCategoryDetalles";
import CardConfigFixture from "../../components/Cards/CardConfiguration/CardConfigFixture/CardConfigFixture";
import CardConfigClasificacionFaseFinal from "../../components/Cards/CardConfiguration/CardConfigClasificacionFaseFinal/CardConfigClasificacionFaseFinal.jsx";
import CardConfigPublicTabs from "../../components/Cards/CardConfiguration/CardConfigPublicTabs/CardConfigPublicTabs.jsx";
import CardConfigSportInformation from "../../components/Cards/CardConfiguration/CardConfigSportInformation/CardConfigSportInformation.jsx";
import CardCumulativeSeries from "../../components/Cards/CardConfiguration/CardCumulativeSeries/CardCumulativeSeries.jsx";

import axios from "axios";
import API_BASE_URL from "../../config/config.js";
import { useParams } from "react-router-dom";
import { formatIdSport } from "../../utils/formatIdSport.js";

const ConfigCategoryArea = () => {
  const [sport, setSport] = useState(null);
  const { idsport } = useParams();
  const isRugby = formatIdSport(Number(idsport)) === 6;

  useEffect(() => {
    const fetchDatos = async () => {
      try {
        let sport = await axios.get(
          `${API_BASE_URL}/sport/?idsport=${idsport}`
        );
        setSport(sport.data);
      } catch (error) {
        console.error("Error fetching datos", error);
      }
    };
    if (idsport) {
      fetchDatos();
    }
  }, [idsport]);

  return (
    <>
      <div className="font-quickSand">
        <div className="mx-auto mb-2 max-w-5xl rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-sm">
          <p className="text-[10px] font-black uppercase tracking-[0.2em] text-blue-600">
            Centro de configuración
          </p>
          <h1 className="mt-1 text-2xl font-black text-slate-900">
            Configuración del deporte
          </h1>
          <p className="mt-1 text-sm text-slate-500">
            Los bloques están ordenados por identidad, publicación, clasificación y fixture.
          </p>
        </div>
        <CardConfigCategoryGeneral2 />
        <CardConfigSportInformation />
        {isRugby ? <CardCumulativeSeries /> : null}
        <CardConfigClasificacionFaseFinal />

        {Number(sport?.typeSport) === 3 ? <CardConfigPublicTabs /> : null}

        {sport && sport.isFut ? (
          <>
            <CardConfigCategoryDetalles />
          </>
        ) : null}
        <CardConfigFixture />
      </div>
    </>
  );
};

export default ConfigCategoryArea;
